import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {articleSessionTab_template} from "./articleSessionTab_template";
import {TargetType} from "../../utils/types/article_target";
import {
    validationsList_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {ArticleSessionInterface} from "./articleSessionInterface";

declare var ko: any;
declare var page: any;


export class articleSessionEdit_template extends vnTemplate implements ArticleSessionInterface {


    public successArticleSessionTab: articleSessionTab_template;
    public failureArticleSessionTab: articleSessionTab_template;
    public validationsList: validationsList_template;

    protected getTemplateName(): string {
        return "articleSessionEdit_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="session-target-list-results" class="w-form">
                ${this.validationsList.getHtmlBuild()}
                <div class="form-header" >
                    <h3 class="form-title icon i-target">Article Session Thresholds</h3>
                    <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                </div>
                <div class="form-pagination">
                    <button class="btn icon i-notice-success" type="button" data-bind="event: { click: onClickTab.bind($data,'success') }, css: { 'is-activated' : selectedType() == 'success'}"><span class="btn-text">Success Threshold</span></button>
                    <button class="btn icon i-notice-alert" type="button" data-bind="event: { click: onClickTab.bind($data,'failure') }, css: { 'is-activated' : selectedType() == 'failure'}"><span class="btn-text">Failure Threshold</span></button>
                </div>
                <div class="" data-bind="visible: (selectedType() == 'success')">
                    ${this.successArticleSessionTab.getHtmlBuild()}
                </div>
                <div class="" data-bind="visible: selectedType() == 'failure'">
                    ${this.failureArticleSessionTab.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form-body"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            selectedType: ko.observable(TargetType.SUCCESS),
            contentTypes: ko.observableArray([]),
            onClickTab: (value, data, event): void => {
                self.onClickTab(value);
            },
            onClickCancel: (data, event): void => {
                self.onClickCancel();
            }
        };
    }

    protected initPartial() {
        this.successArticleSessionTab = new articleSessionTab_template('successArticleSessionTab', this.getTemplateViewModel(), this.caller);
        this.successArticleSessionTab.isReadOnly(false);
        this.successArticleSessionTab.setParent(this);
        this.successArticleSessionTab.setType(TargetType.SUCCESS);

        this.failureArticleSessionTab = new articleSessionTab_template('failureArticleSessionTab', this.getTemplateViewModel(), this.caller);
        this.failureArticleSessionTab.isReadOnly(false);
        this.failureArticleSessionTab.setParent(this);
        this.failureArticleSessionTab.setType(TargetType.FAILURE);
        this.failureArticleSessionTab.setSaveFallback(true);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected onClickTab(tab): void {
        this.setSelectedType(tab);
    }

    public setListingSessionTargets(sessionTargets: { success: any, failure: any }): void {

        if (sessionTargets.success) {
            this.successArticleSessionTab.setListingSessionTargets(sessionTargets.success);
        }
        if (sessionTargets.failure) {
            this.failureArticleSessionTab.setListingSessionTargets(sessionTargets.failure);
        }
    }

    public onClickCancel(): void {
        let hasFailureChange = this.failureArticleSessionTab.hasUnsavedBrandSessionTarget();
        let hasSuccessChange = this.successArticleSessionTab.hasUnsavedBrandSessionTarget();
        if (hasSuccessChange || hasFailureChange) {
            if (confirm('Are you sure you want to cancel? any unsaved change will be lost.')) {
                this.redirectToView();
            }
        } else {
            this.redirectToView();
        }
    }

    public redirectToView(): void {
        page('/analytics/article-session-thresholds/view');
    }

    /** Session target brand year dropdown **/
    public setYearSelector(years, currentYear): void {

        if (this.isFailureSelected()) {

            this.successArticleSessionTab.setYearSelector(years, currentYear);
        } else {

            this.failureArticleSessionTab.setYearSelector(years, currentYear);
        }
    }

    public setYearsOnSuccessConfig(years, currentYear): void {

        this.successArticleSessionTab.setYearSelector(years, currentYear);
    }

    public setYearsOnFailureConfig(years, currentYear): void {

        this.failureArticleSessionTab.setYearSelector(years, currentYear);
    }

    public setContentTypes(contentTypes): void {
        this.getTemplateViewModel().contentTypes(contentTypes);
    }

    public getContentTypes() {
        return this.getTemplateViewModel().contentTypes();
    }

    public getYearSelector(): string {

        if (this.isFailureSelected()) {

            return this.failureArticleSessionTab.getYearSelector();
        } else {

            return this.successArticleSessionTab.getYearSelector();
        }
    }

    public getSelectedType(): string {
        return this.getTemplateViewModel().selectedType();
    }

    public setSelectedType(selectedType): string {
        return this.getTemplateViewModel().selectedType(selectedType);
    }

    public isFailureSelected(): boolean {
        let selectedType = this.getSelectedType();

        return (selectedType == TargetType.FAILURE);
    }

    /**
     * Returns a list of session brands to be saved in the system
     */
    public getViewModelForRequest() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getViewModelForRequest();
        } else {
            return this.successArticleSessionTab.getViewModelForRequest();
        }
    }

    public setSuccessSelectedYear(selectedYear): void {
        this.successArticleSessionTab.setSelectedYear(selectedYear);
    }

    public setFailureSelectedYear(selectedYear): void {
        this.failureArticleSessionTab.setSelectedYear(selectedYear);
    }


    public getBrandContentTypeSelectedYear(): string {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getSelectedYear();
        } else {
            return this.successArticleSessionTab.getSelectedYear();
        }
    }

    public toggleBrandSaveDialogVisibility() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.toggleBrandSaveDialogVisibility();
        } else {
            return this.successArticleSessionTab.toggleBrandSaveDialogVisibility();
        }
    }

    /**
     * Toggle the dialog for displaying confirmation on deleting a content type exception
     */
    public toggleBrandContentTypeSaveDialogVisibility() {
        document.getElementById('dialog-brand-content-type-save').classList.toggle('is-visible');
    }

    public toggleContentTypeDeleteDialogVisibility() {
        document.getElementById('dialog-content-type-delete').classList.toggle('is-visible');
    }

    public hasUnsavedBrandSessionTarget() {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.hasUnsavedBrandSessionTarget();
        } else {
            return this.successArticleSessionTab.hasUnsavedBrandSessionTarget();
        }
    }
    public getSelectedYear() {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getSelectedYear();
        } else {
            return this.successArticleSessionTab.getSelectedYear();
        }
    }
    public hasUnsavedContentTypes() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.hasUnsavedContentTypes();
        } else {
            return this.successArticleSessionTab.hasUnsavedContentTypes();
        }
    }

    public setFallback(fallback: number): void {
        this.failureArticleSessionTab.setFallback(fallback);
    }


    public setValidationSessionTargetsExceptions(message) {
        if (this.isFailureSelected()) {
            this.failureArticleSessionTab.setValidationSessionTargetsExceptions(message);
        } else {
            this.successArticleSessionTab.setValidationSessionTargetsExceptions(message);
        }
    }

    public setValidationSessionTargets(messages) {
        this.validationsList.setMessages(messages);
    }
    public clearValidationSessionTargets() {
        this.validationsList.clearMessages();
    }


    public resetContentTypesExceptions() {
        if (this.isFailureSelected()) {
            this.failureArticleSessionTab.resetContentTypesExceptions();
        } else {
            this.successArticleSessionTab.resetContentTypesExceptions();
        }
    }

    public insertSessionTargetsExceptions(): void {
        if (this.isFailureSelected()) {
            this.failureArticleSessionTab.insertSessionTargetsExceptions();
        } else {
            this.successArticleSessionTab.insertSessionTargetsExceptions();
        }
    }

    public resetUnsavedBrandSessionTarget(): void {
        this.validationsList.clearMessages();
    }

    public getSavingElement(): Element {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getSavingElement();
        } else {
            return this.successArticleSessionTab.getSavingElement();
        }
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/articleSessionEdit_template.ts